import React from "react";
import { BookingType } from "./types";

interface BookingTypeSelectorProps {
  selectedType: BookingType;
  onTypeChange: (type: BookingType) => void;
}

export const BookingTypeSelector: React.FC<BookingTypeSelectorProps> = ({
  selectedType,
  onTypeChange,
}) => {
  const bookingTypes: { type: BookingType; label: string }[] = [
    { type: "foto", label: "ФОТО" },
    { type: "video", label: "ВИДЕО" },
    { type: "event", label: "МЕРОПРИЯТИЕ" },
  ];

  return (
    <div className="flex gap-5 max-md:flex-col justify-self-center m-5">
      {bookingTypes.map((bookingType, index) => (
        <div
          key={bookingType.type}
          className={`${index > 0 ? "ml-5 " : ""}w-[33%] max-md:ml-0 max-md:w-full`}
        >
          <button
            className="relative min-w-40 px-8 py-4 text-xs font-light uppercase transition-all cursor-pointer border border-solid duration-[0.3s] ease-[ease] max-sm:w-full"
            onClick={() => onTypeChange(bookingType.type)}
            style={{
              borderColor:
                selectedType === bookingType.type
                  ? "rgb( 160, 160, 160)"
                  : "transparent",
              color: selectedType === bookingType.type ? "black" : "rgb( 60, 60, 60)",
            }}
          >
            <span>{bookingType.label}</span>
            {selectedType === bookingType.type && (
              <div className="absolute right-2.5 top-2/4 bg-amber-500 rounded -translate-y-2/4 h-[5px] w-[5px]" />
            )}
          </button>
        </div>
      ))}
    </div>
  );
};
        
